<template>
  <div>
    <integration-detail-field class="mb-3">
      <div slot="label">Wit.ai Console:</div>
      <div slot="value">
        <external-link href="https://wit.ai/home" title="wit.ai" />
      </div>
    </integration-detail-field>
    <integration-detail-field class="mb-3 align-items-center" v-if="!editMode">
      <div slot="label">Access Token:</div>
      <div slot="value">
        <sensitive-field readonly :text="integration.access_token"/>
      </div>
    </integration-detail-field>
    <form-input v-else
                label="Access Token"
                :value="form.access_token"
                :error="errors.access_token"
                @form-input="form.access_token = $event"></form-input>

  </div>
</template>

<script>
  import IntegrationDetailField from '@/components/administration/common/Field'
  import 'vue-awesome/icons/external-link-alt'
  import FormInput from '@/components/administration/common/form/FormInput'
  import ExternalLink from '@/components/common/ExternalLink'
  import SensitiveField from '@/components/common/SensitiveField'

  export default {
    props: {
      editMode: Boolean,
      errors: {
        type: Object,
        default: () => ({})
      }
    },

    components: {
      SensitiveField,
      'integration-detail-field': IntegrationDetailField,
      'form-input': FormInput,
      'external-link': ExternalLink
    },

    store: {
      integration: 'administration.integrationDetail.integration',
      form: 'administration.integrationDetail.integrationEdit.editableData'
    },

    watch: {
      editMode: function () {
        if (!this.editMode) return

        this.form.access_token = this.integration.access_token
      }
    }
  }
</script>
